export default __webpack_public_path__ + "media/images/builder_128-09ee66eafe73bc668b4b8beda76d1a96.png";